
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/studio-manual',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/studio-manual/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual" */
              '/work/studio-manual/_site_tmp/_studio-manual.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/3d-buildings/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-3d-buildings" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_3d-buildings.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/atmosphere/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-atmosphere" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_atmosphere.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/choropleth-map/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-choropleth-map" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_choropleth-map.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/conditional-labels/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-conditional-labels" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_conditional-labels.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/convert-units/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-convert-units" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_convert-units.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/custom-icon/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-custom-icon" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_custom-icon.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/custom-icons-generic-markers/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-custom-icons-generic-markers" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_custom-icons-generic-markers.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/heatmap-layer/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-heatmap-layer" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_heatmap-layer.js'
            ),
            
            
          },{
            path: '/studio-manual/examples/hillshade/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-examples-hillshade" */
              '/work/studio-manual/_site_tmp/_studio-manual_examples_hillshade.js'
            ),
            
            
          },{
            path: '/studio-manual/guides/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-guides" */
              '/work/studio-manual/_site_tmp/_studio-manual_guides.js'
            ),
            
            
          },{
            path: '/studio-manual/guides/components/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-guides-components" */
              '/work/studio-manual/_site_tmp/_studio-manual_guides_components.js'
            ),
            
            
          },{
            path: '/studio-manual/guides/geospatial-data/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-guides-geospatial-data" */
              '/work/studio-manual/_site_tmp/_studio-manual_guides_geospatial-data.js'
            ),
            
            
          },{
            path: '/studio-manual/guides/map-styling/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-guides-map-styling" */
              '/work/studio-manual/_site_tmp/_studio-manual_guides_map-styling.js'
            ),
            
            
          },{
            path: '/studio-manual/guides/publish-your-style/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-guides-publish-your-style" */
              '/work/studio-manual/_site_tmp/_studio-manual_guides_publish-your-style.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/datasets/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-datasets" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_datasets.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/datasets/sections/dataset-editor/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-datasets-sections-dataset-editor" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_datasets_sections_dataset-editor.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/datasets/sections/introduction/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-datasets-sections-introduction" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_datasets_sections_introduction.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/datasets/sections/manage-datasets/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-datasets-sections-manage-datasets" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_datasets_sections_manage-datasets.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/components/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-components" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_components.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/introduction/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-introduction" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_introduction.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/layers/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-layers" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_layers.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/manage-styles/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-manage-styles" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_manage-styles.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/map-canvas/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-map-canvas" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_map-canvas.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/styles/sections/toolbar/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-styles-sections-toolbar" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_styles_sections_toolbar.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/tilesets/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-tilesets" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_tilesets.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/tilesets/sections/introduction/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-tilesets-sections-introduction" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_tilesets_sections_introduction.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/tilesets/sections/manage-tilesets/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-tilesets-sections-manage-tilesets" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_tilesets_sections_manage-tilesets.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/tilesets/sections/pricing/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-tilesets-sections-pricing" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_tilesets_sections_pricing.js'
            ),
            
            
          },{
            path: '/studio-manual/reference/tilesets/sections/tileset-info-page/',
            getPage: () => import(
              /* webpackChunkName: "studio-manual-reference-tilesets-sections-tileset-info-page" */
              '/work/studio-manual/_site_tmp/_studio-manual_reference_tilesets_sections_tileset-info-page.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };